import { createAction, handleActions } from 'redux-actions';
import produce from 'immer';
import set from 'lodash/set';

const CHANGE_VALUE = 'buyInquiry/CHANGE_VALUE';
export const changeValue = createAction(CHANGE_VALUE);
const CHANGE_TERMS = 'buyInquiry/CHANGE_TERMS';
export const changeTerms = createAction(CHANGE_TERMS);

const initialState = {
	textInquiry: '',
	phoneNumber: '',
	inquiryItems: [],
	isExchange: 'exchangeNo',
	selectCategory: '',
	termsAgreement: {
		personal: false,
		thirdPartyConsent: false,
		thirdPartyConsentOption: false,
	},
};

export default handleActions(
	{
		[CHANGE_VALUE]: (state, action) =>
			produce(state, (draft) => {
				const { name, value } = action.payload;
				draft[name] = value;
			}),
		[CHANGE_TERMS]: (state, action) =>
			produce(state, (draft) => {
				const { name, value } = action.payload;
				set(draft, ['termsAgreement', name], value);

				return draft;
			}),
	},
	initialState,
);
